import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=645e4aea&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645e4aea')) {
      api.createRecord('645e4aea', component.options)
    } else {
      api.reload('645e4aea', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=645e4aea&", function () {
      api.rerender('645e4aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85s25qlC5ou5P/JS/comp/seasonprices.vue"
export default component.exports